export default {
	NotApplicable: 0,
	Optional: 1,
	Required: 2
};
